import Controller from '@ember/controller';
import { action } from '@ember/object';
import { service } from '@ember/service';
import { tracked } from '@glimmer/tracking';
import { ActiveItemCache } from 'scaleflow/utils/active-item-cache';

export default class TeamsTeamCheckInController extends Controller {
  @service router;
  @service store;
  @tracked allCommentsOpen = false;
  @tracked active_item = new ActiveItemCache();
  @service('beta-toggle') betaService;
  @service('current-user') currentUser;
  @service('editor-active') editorActiveService;
  queryParams = ['tags', 'mentions', 'item'];

  @tracked tags = null;
  @tracked mentions = null;
  @tracked item = null;
  @tracked model;

  @tracked _questions = [];
  @tracked _lls = [];
  @tracked _tfos = [];
  @tracked _wfas = [];
  @tracked _uncertainties = [];
  @tracked _usefulLinks = [];

  @tracked bookmark_form = null;
  @tracked showModal = false;
  bookmarkValidations = this.bookmarkValidations;

  visibleBadges = ['initiatives', 'workstreams', 'delay'];
  // uncertaintyBadges = ['initiatives'];
  // wfaBadges = ['initiatives'];
  initiativeBadge = ['initiatives'];

  llBadges = [];

  get questions() {
    return this.store
      .peekAll('question')
      .filter(
        (item) =>
          item.team.get('id') === this.model.id &&
          item.archived === false &&
          item.isDeleted === false,
      );
  }

  get lls() {
    return this.store
      .peekAll('ll')
      .filter(
        (item) =>
          item.team.get('id') === this.model.id &&
          item.archived === false &&
          item.isDeleted === false,
      );
  }

  get tfos() {
    const items = this.store
      .peekAll('tfo')
      .filter(
        (item) =>
          item.team.get('id') === this.model.id &&
          item.archived === false &&
          item.isDeleted === false,
      );
    return items;
  }

  get wfas() {
    return this.store
      .peekAll('wfa')
      .filter(
        (item) =>
          item.team.get('id') === this.model.id &&
          item.archived === false &&
          item.isDeleted === false,
      );
  }

  get uncertainties() {
    return this.store
      .peekAll('uncertainty')
      .filter(
        (item) =>
          item.team.get('id') === this.model.id &&
          item.archived === false &&
          item.isDeleted === false,
      );
  }

  get usefulLinks() {
    return this.store
      .peekAll('bookmark')
      .filter((item) => item.team.get('id') === this.model.id);
  }

  get showUncertainties() {
    return this.model?.show_uncertainties;
  }

  get showWfas() {
    return this.model?.show_wfa;
  }

  get breadcrumbsArr() {
    return this.breadcrumbService.breadcrumbs;
  }

  get tagFilter() {
    return this.tags;
  }

  get mentionFilter() {
    return this.mentions;
  }

  @action
  toggleAllComments() {
    this.allCommentsOpen = !this.allCommentsOpen;
  }

  @action
  isActive(list_name, item, editor_id) {
    if (item.assignees.length < 2) {
      return item.id == this.editorActiveService.activeItem;
    } else {
      return this.editorActiveService.activeEditorId === editor_id;
    }
  }

  @action
  activate(list_name, item) {
    this.editorActiveService.setActiveItem(item?.id);
    return false;
  }

  @action
  removeTag() {
    this.tags = null;
  }

  @action
  removeMention() {
    this.mentions = null;
  }

  @action
  handlePageUpdate() {}

  @action
  scrollToItem() {
    const item = document.querySelector(`#id-${this.item} .-ml-2`);
    if (item) {
      item.scrollIntoView({ behavior: 'smooth' });
      item.classList.add('bg-purple-100');
      setTimeout(() => item.classList.remove('bg-purple-100'), 2500);
    }
  }

  @action
  showBookmarkModal() {
    this.showModal = true;
    this.bookmark_form = this.store.createRecord('bookmark');
  }

  @action
  hideModal() {
    this.showModal = false;
    this.bookmark_form = null;
  }

  @action
  async addUsefulLink(changeset) {
    if (changeset.title?.length <= 0) return;
    if (changeset.icon?.length <= 0) return;
    if (changeset.url?.length <= 0) return;
    try {
      this.bookmark_form.title = changeset.title;
      this.bookmark_form.icon = changeset.icon;
      this.bookmark_form.url = changeset.url;
      this.bookmark_form.team = this.model;
      this.bookmark_form.save().then(() => {
        this.hideModal(false);
        changeset.rollback();
      });
    } catch (err) {
      console.log(err);
    }
    // console.log(changeset.error);
  }

  @action
  editBookmark(bookmark) {
    this.bookmark_form = bookmark;
    this.showModal = true;
  }
}
